import { Tooltip, Stack } from '@mui/material'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { H1Sendmail, J2Forbidden } from '@e3dc-react/icons'
import { InstallationWithoutAccess } from 'src/Libs/installations/models'
import { AccessRightOptions } from 'src/Routes/Installation/InstallationModel'
import { checkIsDateLessThanTwoWeeks } from 'src/Libs/installations/utils'
import { format } from '@e3dc-react/shell/Libs/date'

interface Props {
  installation: InstallationWithoutAccess
}

/**
 * This component shows icon with a tooltip for installations without access.
 */
const NoAccessToInstallationTooltip: React.FC<Props> = ({ installation }) => {
  const { t } = useCustomTranslation()
  const { permissionType, accessRequestAt } = installation
  const isAccessToInstallationPending = permissionType === AccessRightOptions.pending && checkIsDateLessThanTwoWeeks(accessRequestAt)
  const hasExpiredPendingRequest = permissionType === AccessRightOptions.pending && !checkIsDateLessThanTwoWeeks(accessRequestAt)

  const hasNoAccessToInstallation =
    permissionType === AccessRightOptions.noAccess || permissionType === AccessRightOptions.blocked || hasExpiredPendingRequest

  const showNoAccessToTooltip = hasNoAccessToInstallation || isAccessToInstallationPending

  const formattedAccessRequestDate = accessRequestAt ? format(new Date(accessRequestAt), t('common.format.date-fns-date')) : ''

  const title = isAccessToInstallationPending
    ? t('errors.installation.access-to-installation-pending', { accessRequestDate: formattedAccessRequestDate })
    : t('errors.installation.no-access-to-installation')

  if (!showNoAccessToTooltip) return null

  return (
    <Tooltip title={title} placement="top-start">
      <Stack component="span">
        {isAccessToInstallationPending ? (
          <H1Sendmail sx={{ color: 'primary.main', width: 4, height: 4 }} />
        ) : (
          <J2Forbidden sx={{ color: 'error.main', width: 4, height: 4 }} />
        )}
      </Stack>
    </Tooltip>
  )
}

export default NoAccessToInstallationTooltip
